import { createSession } from './methods/createSession';

import { fetchSurveyForm } from './methods/fetchSurveyForm';
export {
  TechnicalError,
  IncorrectDataError,
  OtherError,
  UnknownServerMessageError,
  SurveyFormFetchingError,
  SurveyAlreadyCompletedError,
  SurveyFormFetchingCodeError
} from './methods/fetchSurveyForm';

import { sendUserAnswer } from './methods/sendUserAnswer';
export { type UserAnswerToSend } from './methods/sendUserAnswer';

import { sendSurveyStatus } from './methods/sendSurveyStatus';

export const Api = { createSession, fetchSurveyForm, sendUserAnswer, sendSurveyStatus };

export { ApiError } from './types';
